import { largeNumberDisplay } from '@/utils/helpers';

function createRow() {
  const element = document.createElement('div');
  element.className = 'chart-live-tooltip__row';
  const swatch = document.createElement('span');
  swatch.className = 'chart-live-tooltip__swatch';
  const name = document.createElement('span');
  name.className = 'chart-live-tooltip__name';
  const price = document.createElement('strong');
  element.append(swatch, name, price);
  return { element, swatch, name, price };
}

function updateRow(row, entry) {
  row.swatch.style.backgroundColor = entry.color;
  row.name.textContent = entry.name;
  row.price.textContent = `${entry.price}¢`;
}

function updateVolume(element, volume) {
  element.replaceChildren();
  element.hidden = !volume || !Number.isFinite(volume.value);
  if (element.hidden) return;
  const label = document.createElement('span');
  label.textContent = 'Total Volume';
  const value = document.createElement('strong');
  value.textContent = largeNumberDisplay(volume.value, false);
  element.append(label, value);
}

// Use DOM text nodes for names and dates: market data must never become markup.
export function historicalChartTooltip(points) {
  if (!points?.length) return '';
  const card = document.createElement('div');
  card.className = 'chart-live-tooltip chart-live-tooltip--history';
  const header = document.createElement('div');
  header.className = 'chart-live-tooltip__header';
  header.textContent = String(points[0].key);
  card.append(header);
  const prices = points.filter((p) => p.series.options.contractId != null && Number.isFinite(p.y));
  for (const point of prices.sort((a, b) => b.y - a.y)) {
    const row = createRow();
    updateRow(row, { name: point.series.name, color: point.series.color, price: point.y });
    card.append(row.element);
  }
  const volumePoint = points.find((p) => p.series.name === 'Total Volume' && p.series.visible);
  if (volumePoint) {
    const volume = document.createElement('div');
    volume.className = 'chart-live-tooltip__volume';
    updateVolume(volume, { value: volumePoint.y });
    card.append(volume);
  }
  return card.outerHTML;
}

export function createLiveChartTooltip(host, id) {
  const tooltip = document.createElement('div');
  tooltip.className = 'chart-live-tooltip';
  tooltip.id = id;
  tooltip.role = 'tooltip';
  tooltip.hidden = true;
  const header = document.createElement('div');
  header.className = 'chart-live-tooltip__header';
  const status = document.createElement('span');
  status.className = 'chart-live-tooltip__status';
  status.setAttribute('aria-hidden', 'true');
  header.append(status, document.createTextNode('Live'));
  tooltip.append(header);
  host.append(tooltip);
  const rows = new Map();
  return {
    element: tooltip,
    update(entries) {
      const ids = new Set(entries.map((entry) => entry.contractId));
      for (const [key, row] of rows) {
        if (!ids.has(key)) {
          row.element.remove();
          rows.delete(key);
        }
      }
      for (const entry of [...entries].sort((a, b) => b.price - a.price)) {
        let row = rows.get(entry.contractId);
        if (!row) {
          row = createRow();
          rows.set(entry.contractId, row);
        }
        updateRow(row, entry);
        tooltip.append(row.element);
      }
    },
    position(x, top) {
      tooltip.style.left = `${Math.max(4, Math.min(x - tooltip.offsetWidth - 14, host.clientWidth - tooltip.offsetWidth - 4))}px`;
      tooltip.style.top = `${Math.max(4, Math.min(top, host.clientHeight - tooltip.offsetHeight - 4))}px`;
    },
    dispose() {
      tooltip.remove();
      rows.clear();
    },
  };
}
